import type { IComponentController, IScope } from "angular";

import { finalize } from "rxjs/operators";

import type {
    IConfigurationGroup,
    IConfigurationGroupDetection,
    IResponseWithLoading,
    ISite,
} from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IModalService } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class SiteConfigurationGroupDetectionComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "mmModalService", "mmSitesRepository"];

    public configurationGroup: IConfigurationGroup;

    public site: ISite;

    public configurationGroupDetection: IResponseWithLoading<IConfigurationGroupDetection>;

    public deleted: (params: { id: string }) => void;

    constructor(
        private readonly $scope: IScope,
        private readonly modalService: IModalService,
        private readonly sitesRepository: ISitesRepository,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(
            this.sitesRepository.getConfigurationGroupDetection(
                this.configurationGroup.siteId,
                this.configurationGroup.id,
            ),
        )
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (result) => {
                    this.configurationGroupDetection = result;
                },
                (result) => {
                    this.configurationGroupDetection = result;
                },
            );
    }

    public editConfiguration() {
        this.modalService
            .open<IConfigurationGroupDetection, void>(
                "mmConfigurationGroupDetectionEdit",
                this.configurationGroupDetection.data,
                null,
                "xlg",
            )
            .subscribe(
                (editedConfiguration) => {
                    if (editedConfiguration !== null) {
                        this.configurationGroupDetection.data = editedConfiguration;
                        this.configurationGroup.name = editedConfiguration.name;
                    } else {
                        this.deleted({ id: this.configurationGroup.id });
                    }
                },
                (reason) => reason,
            );
    }
}
